// extracted by mini-css-extract-plugin
export var cardIcon = "_ad-4";
export var checkboxCard = "_ad-0";
export var checkboxCardSelected = "_ad-1";
export var disabled = "_ad-2";
export var outerBorder = "_ad-3";
export var spacerMedium = "_ad-7";
export var spacerSmall = "_ad-6";
export var spacerXsmall = "_ad-5";